var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingL4 = function SvgEarRingL4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 25,
    height: 33,
    viewBox: "0 0 0.46 0.62",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2314197518048"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.38.18C.36.13.3.1.24.1M.09.17C.06.2.05.24.05.29.04.43.04.53.21.57.26.58.4.58.41.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.18.27c.06-.02.19.05.1.08C.22.37.22.41.31.41c.01 0 .02.01.03.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.12.06C.05.11.15.18.18.1.18.08.16.07.15.06.14.06.13.05.12.06zM.04.11c0-.03.01-.07.05-.1C.1 0 .12 0 .14 0c.01 0 .02.01.03.01h.01c.04.02.07.04.05.11C.21.17.18.19.15.19.12.2.1.19.08.17A.068.068 0 0 1 .04.11z",
    fill: "#000"
  })))));
};

export default SvgEarRingL4;